<script>
    import { createEventDispatcher, onMount } from "svelte";
    import { _ } from "svelte-i18n";

    export let value; // Bound to parent (selected variant ID)
    export let replacedItem = { variants: [], variant_options: [] }; // Ensure default values

    let selectedOptions = {}; // Stores selected values for each option type
    let optionTypes = []; // Holds the different option names dynamically

    const dispatch = createEventDispatcher();

    // Extract option types from product_options and variant_options
    function extractOptionTypes() {
        let productOptionTypes = replacedItem.variants?.length
            ? Array.from(
                new Set(
                    replacedItem.variants.flatMap(variant =>
                        Object.values(variant.product_options || {}).map(opt => opt.name)
                    )
                )
            )
            : [];

        let variantOptionTypes = replacedItem.variant_options?.length
            ? Array.from(
                new Set(
                    replacedItem.variant_options.flatMap(variant =>
                        Object.keys(variant.attributes || {})
                    )
                )
            )
            : [];

        // Merge both option types, removing duplicates
        optionTypes = [...new Set([...productOptionTypes, ...variantOptionTypes])];

        // Initialize selected options with empty values
        selectedOptions = Object.fromEntries(optionTypes.map(option => [option, ""]));
    }

    // Get available values for a given option type
    function getAvailableOptions(optionType) {
        let productOptions = replacedItem.variants?.length
            ? replacedItem.variants
                  .flatMap(variant => Object.values(variant.product_options || {}))
                  .filter(opt => opt.name === optionType)
                  .map(opt => opt.value)
            : [];

        let variantOptions = replacedItem.variant_options?.length
            ? replacedItem.variant_options
                  .flatMap(variant => Object.entries(variant.attributes || {}))
                  .filter(([key]) => key === optionType)
                  .map(([, value]) => decodeURIComponent(value))
            : [];

        return [...new Set([...productOptions, ...variantOptions])]; // Merge and remove duplicates
    }

    // Update the selected variant based on chosen options
    function updateSelectedVariant() {
        let matchedVariant = replacedItem.variants?.find(variant =>
            Object.entries(selectedOptions).every(([key, value]) => {
                const option = Object.values(variant.product_options || {}).find(opt => opt.name === key);
                return option?.value === value;
            })
        );

        if (!matchedVariant) {
            matchedVariant = replacedItem.variant_options?.find(variant =>
                Object.entries(selectedOptions).every(([key, value]) => {
                    return variant.attributes?.[key] === value;
                })
            );
        }

        if (matchedVariant) {
            value = matchedVariant.variant_id;
            dispatch("update", value);
        }
    }

    onMount(() => {
        extractOptionTypes();
    });
</script>

<div>
    {#each optionTypes as optionType}
        <label>{optionType}</label>
        <select bind:value={selectedOptions[optionType]} on:change={updateSelectedVariant}>
            <option value="">{$_('dashboard.choose_option')}</option>
            {#each getAvailableOptions(optionType) as optionValue}
                <option value="{optionValue}">{optionValue}</option>
            {/each}
        </select>
    {/each}
</div>
